import { useEffect, useMemo, useState } from "react"

const useOpenInApp = (token) => {
  const [showOpenAppBanner, setShowOpenAppBanner] = useState(false)

  const isMobile = useMemo(() => {
    if (typeof navigator === "undefined") return false
    const ua = navigator.userAgent || navigator.vendor || ""
    return /android|iphone|ipad|ipod/i.test(ua)
  }, [])

  const isIOS = useMemo(() => {
    if (typeof navigator === "undefined") return false
    return /iphone|ipad|ipod/i.test(navigator.userAgent)
  }, [])

  const isAndroid = useMemo(() => {
    if (typeof navigator === "undefined") return false
    return /android/i.test(navigator.userAgent)
  }, [])

  useEffect(() => {
    if (isMobile) {
      setShowOpenAppBanner(true)
    }
  }, [isMobile])

  const handleOpenInApp = () => {
    const deeplink = `aigree://share?token=${encodeURIComponent(token || "")}`
    const fallbackAndroid =
      "https://play.google.com/store/apps/details?id=com.aigreern"
    const fallbackIOS = "https://apps.apple.com/" // TODO: replace with actual App Store app URL when available

    let fallbackTimer

    const clearFallback = () => {
      if (fallbackTimer) clearTimeout(fallbackTimer)
      document.removeEventListener("visibilitychange", onVisibilityChange)
      window.removeEventListener("pagehide", onPageHide)
      window.removeEventListener("blur", onPageHide)
    }

    const onVisibilityChange = () => {
      if (document.hidden || document.visibilityState === "hidden") {
        clearFallback()
      }
    }
    const onPageHide = () => clearFallback()

    document.addEventListener("visibilitychange", onVisibilityChange)
    window.addEventListener("pagehide", onPageHide)
    window.addEventListener("blur", onPageHide)

    const startFallbackTimer = (url) => {
      fallbackTimer = setTimeout(() => {
        window.location.href = url
      }, 1600)
    }

    // iOS
    if (isIOS) {
      startFallbackTimer(fallbackIOS)
      window.location.href = deeplink
      return
    }

    // Android: try intent first
    if (isAndroid) {
      const intentUrl = `intent://share?token=${encodeURIComponent(
        token || ""
      )}#Intent;scheme=aigree;package=com.aigreern;end`
      startFallbackTimer(fallbackAndroid)
      try {
        window.location.href = intentUrl
      } catch (e) {
        clearFallback()
        window.location.href = fallbackAndroid
      }
      return
    }

    // Desktop
    clearFallback()
  }

  return {
    showOpenAppBanner,
    setShowOpenAppBanner,
    handleOpenInApp,
    isMobile,
    isIOS,
    isAndroid,
  }
}

export default useOpenInApp
